export const AppType = {
  isInWeChat: function() {
    // 判断是否是在微信内打开
    return /MicroMessenger/i.test(window.navigator.userAgent)
  },
  isInQQ: function() {
    // 判断是否是在微信内打开
    return /QQ/i.test(window.navigator.userAgent) && /mobile/i.test(window.navigator.userAgent)
  },
  isInApp: function() {
    // 包含bmb and bmLive
    return /Banma/i.test(window.navigator.userAgent)
  },
  isInBmApp: function() {
    return /Banma/i.test(window.navigator.userAgent) && !/BanmaLive/i.test(window.navigator.userAgent)
  },
  isInLiveApp: function() {
    return /BanmaLive/i.test(window.navigator.userAgent)
  },
  isInAndroid: function() {
    // android终端
    var u = navigator.userAgent
    return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
  },
  isInIOS: function() {
    // ios终端
    var u = navigator.userAgent
    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  }
}
